import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getCampaignDefaults } from '../../selectors';
import Landing from './Landing/landing';
import NavHeader from '../Header/nav.header';
import CustomerJourney from './CustomerJourney/customer.journey';
import { marketCodeChanged } from "../../actions";
import { MarketCodes } from "../../marketCodes";
import PropTypes from 'prop-types';

export class LandingPage extends React.Component {

  componentDidMount() {
    this.props.marketCodeChanged(MarketCodes.DIRECT_MAILER);
  }

  render() {
    return (<article className="landing-page">
      <NavHeader showNavigationLinks={true}/>
      <Landing campaignDefaults={this.props.campaignDefaults} />
      <CustomerJourney />
    </article>
    );
  }
}

LandingPage.propTypes = {
  marketCodeChanged: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  campaignDefaults: PropTypes.object
};

const mapStateToProps = (state) => ({
  campaignDefaults: getCampaignDefaults(state)
});

const mapDispatchToProps = dispatch => ({
  ...bindActionCreators({ marketCodeChanged },
    dispatch,
  ),
  dispatch: dispatch
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
